import {
  assignedLocationIdsSchema,
  assignedOfficeSchema,
  assignedRegionIdsSchema,
  phoneNumberSchema,
  productRegionPreferenceSchema,
  usernameSchema,
} from 'modules/user/schemas';
import * as yup from 'yup';

import { EditUserFields } from './enum';

const {
  firstName,
  lastName,
  phoneNumber,
  productRegionPreference,
  assignedOffice,
  assignedRegionIds,
  assignedLocationIds,
} = EditUserFields;

type EditUserInfoSchema = {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  productRegionPreference?: string | null;
  assignedOffice?: string | null;
  assignedRegionIds?: string[] | null;
  assignedLocationIds?: string[] | null;
};

const editUserInfoSchema: yup.SchemaOf<EditUserInfoSchema> = yup.object({
  [firstName]: usernameSchema,
  [lastName]: usernameSchema,
  [phoneNumber]: phoneNumberSchema,
  [productRegionPreference]: productRegionPreferenceSchema.nullable(),
  [assignedOffice]: assignedOfficeSchema.nullable(),
  [assignedRegionIds]: assignedRegionIdsSchema,
  [assignedLocationIds]: assignedLocationIdsSchema,
});

export { editUserInfoSchema };
export type { EditUserInfoSchema };
